import { IMessage } from "@home-health-notify/domain";
import {
  ForwardedInfoBox,
  InfoContentDetail,
  InfoContentWrapper,
} from "../MessagePanel.style";
import { useTranslation } from "hhn-commons";

interface MessageForwardedInfoContentProps {
  message: IMessage;
}

const MessageForwardedInfoContent = ({
  message,
}: MessageForwardedInfoContentProps) => {
  const { t } = useTranslation();
  const tNs = (key: string) => t(key, { ns: "chat" });
  const forwardedFrom = message.getMessage().forwardedFrom;
  const chatType = `- ${forwardedFrom?.chatType ?? ""}`;
  const chatName = ` ${forwardedFrom?.chatName ?? ""} `;
  const senderName = `${forwardedFrom?.senderName ?? ""} `;

  return (
    <ForwardedInfoBox data-testid="forwarded-info-content">
      {tNs("messageInfo.originallySentBy")}
      <InfoContentWrapper>
        <InfoContentDetail>{senderName}</InfoContentDetail>
        {tNs("messageInfo.in")}
        <InfoContentDetail>{chatName}</InfoContentDetail>
        {chatType}
      </InfoContentWrapper>
    </ForwardedInfoBox>
  );
};
export default MessageForwardedInfoContent;
